import React      from 'react';
import Parse      from 'parse';
import GrayNavBar from './layout/gray-navbar';
import UserNavbar from './layout/user-navbar';

const Privacy = () =>
(
    <div>

        {
            Parse.User.current() ? <UserNavbar /> : <GrayNavBar />
        }

        <div className="section terms-pg">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                  <div className="about-box">
                      <h1 className="text-center">Privacy Policy</h1>

                    <p>
                        FreshBytes, LLC (&quot;FreshBytes&quot;, &quot;us&quot;, &quot;our&quot;, and &quot;we&quot;) is committed to maintaining robust privacy protections for its users. Our Privacy Policy
                        (&quot;Privacy Policy&quot;) is designed to help you understand how we collect, use, and safeguard the information you provide to us and to assist you in making
                        informed decisions when using our Service.
                    </p>
                    <p>
                        <strong>
                            By accepting our Privacy Policy and Terms of Use (located at www.freshbytes.io/terms), you consent to our collection, storage, use and
                            disclosure of your personal information as described in this Privacy Policy.
                        </strong>
                    </p>
                    <p>
                        <strong>Children’s Online Privacy Protection Act</strong>
                    </p>
                    <p>
                        We do not intentionally gather Personal Information from visitors who are under the age of 13.
                    </p>
                    <p>
                        <strong>Types of Data We Collect</strong>
                    </p>
                    <p>
                        We collect &quot;Non-Personal Information&quot; and &quot;Personal Information.&quot; Non-Personal Information includes information that cannot be used to personally identify
                        you, such as anonymous usage data, general demographic information we may collect, referring/exit pages and URLs, platform types, preferences you submit
                        and preferences that are generated based on the data you submit and number of clicks. &quot;Personal Information&quot; means data that allows someone to identify or
                        contact you, including, for example, your name, address, telephone number, e-mail address, as well as any other non-public information about you that is
                        associated with or linked to any of the foregoing data. While we host websites and apps for Restaurants, your use of that website or app is subject to
                        Restaurant’s terms and privacy policy.
                    </p>
                    <p>
                        <strong>Information You Provide to Us</strong>
                    </p>
                    <ul>
                        <li>
                            We may collect Personal Information from you, such as your first and last name, e-mail and mailing address, phone and password when you create an
                            account to log in to our network (&quot;Account&quot;).
                        </li>
                        <li>
                            When you subscribe to the Services on our Site or Mobile App, or a Restaurant Site or Mobile App powered by FreshBytes (&quot;Restaurant Site/App&quot;),
                            our payment processor will collect all information necessary to complete the transaction, including your name, credit card information, billing
                            information and—for Restaurant owners—direct deposit information. We use reasonable industry standards to process transactions. When you initially provide or update your payment information, we transmit it  via an encrypted connection to our payment processor, Stripe. Stripe uses and process your payment information in accordance with <a href="https://stripe.com/privacy/">Stripe’s Privacy Policy</a>. We do not store credit
                            card information. We only store an encrypted token in order to communicate with the payment processor.
                        </li>
                        <li>
                            We retain information on your behalf, such as files and messages that you store using your Account.
                        </li>
                        <li>
                            If you provide us feedback or contact us via e-mail, we will collect your name and e-mail address, as well as any other content included in the e-mail,
                            in order to send you a reply.
                        </li>
                        <li>
                            When you participate in one of our surveys, we may collect additional information that you knowingly provide.
                        </li>
                        <li>
                            When you post messages on the Services or on a Social Media Site (&quot;SMS&quot;) where we have a page or presence (collectively &quot;SMS Pages&quot;), the information
                            contained in your posting may be republished on our Site or Mobile App and other users may be able to see them.
                        </li>
                    </ul>
                    <p>
                        <strong>Information Collected via Technology</strong>
                    </p>
                    <ul>
                        <li>
                            In an effort to improve the quality of the Service, we track information provided to us by your browser or by our software application when you view or
                            use the Service, such as the website you came from (known as the &quot;referring URL&quot;), the type of browser you use, the device from which you connected to
                            the Service, the time and date of access, and other information that does not personally identify you. We track this information using cookies, or
                            small text files which include an anonymous unique identifier. Cookies are sent to a user’s browser from our servers and are stored on the user’s
                            computer hard drive. Sending a cookie to a user’s browser enables us to collect Non-Personal information about that user and keep a record of the
                            user’s preferences when utilizing our services, both on an individual and aggregate basis.
                        </li>
                        <li>
                            We may also use third party analytics services such as Google Analytics or Google Adsense to collect information about how you use and interact with
                            our Services. Such third party analytics services may use cookies to gather information such as the pages you visited, your IP address, a date/time
                            stamp for your visit and which site referred you to the Site.
                        </li>
                    </ul>
                    <p>
                        <strong>Use of Your Personal Information</strong>
                    </p>
                    <p>
                        In general, Personal Information you submit to us is used either to respond to requests that you make, or to aid us in serving you better. We use your
                        Personal Information in the following ways:
                    </p>
                    <ul>
                        <li>
                            to facilitate the creation of and secure your Account on our network;
                        </li>
                        <li>
                            identify you as a user in our system;
                        </li>
                        <li>
                            provide improved administration of our Services;
                        </li>
                        <li>
                            provide the Services you request;
                        </li>
                        <li>
                            improve the quality of experience when you interact with our Services, such as storing delivery addresses and past orders for ease of use;
                        </li>
                        <li>
                            send you a welcome e-mail to verify ownership of the e-mail address provided when your Account was created;
                        </li>
                        <li>
                            send you administrative e-mail notifications, such as security or support and maintenance advisories;
                        </li>
                        <li>
                            respond to your inquiries related to employment opportunities or other requests;
                        </li>
                        <li>
                            to send newsletters, surveys, offers, and other promotional materials related to our Services and for other marketing purposes including those of third
                            parties; and
                        </li>
                        <li>
                            perform marketing or data analysis.
                        </li>
                    </ul>
                    <p>
                        No Sales of Personal Information. We will not sell Personal Information that we collect from you to any third parties. Your Personal Information however,
                        may be part of transferred assets in the event of a corporate sale, merger, reorganization, sale of assets, dissolution, or similar event.
                    </p>
                    <p>
                        <strong>Use of Non-Personal Information</strong>
                    </p>
                    <p>
                        In general, we use Non-Personal Information to help us improve the Service and customize the user experience. We also aggregate Non-Personal Information in
                        order to track trends and analyze use patterns on the Site. Non-Personal Information includes web analytics such as browser types and versions, operating
                        systems and device types, internet service providers, the Internet Protocol (IP) address connecting your computer to the internet average, and analytics
                        pertaining to time spent on our site(s) and pages viewed. This Privacy Policy does not limit in any way our use or disclosure of Non-Personal Information
                        and we reserve the right to use and disclose such Non-Personal Information to our partners, advertisers and other third parties at our discretion.
                    </p>
                    <p>
                        If our information practices change at any time in the future, we will post the policy changes to the Site so that you may opt out of the new information
                        practices. We suggest that you check the Site periodically if you are concerned about how your information is used.
                    </p>
                    <p>
                        <strong>Location-Based Data</strong>
                    </p>
                    <p>
                        FreshBytes makes use of location-based data for our Website to locate restaurants in your geographic area. If you choose not to allow
                        FreshBytes to access your location, some or all functionality of the Services may not be available to you.
                    </p>
                    <p>
                        <strong>Disclosure of Your Personal Information</strong>
                    </p>
                    <p>
                        We disclose your Personal Information as described below and as described elsewhere in this Privacy Policy.
                    </p>
                    <p>
                        Third Party Service Providers. We may share your Personal Information with third party service providers to: provide you with the Services that we offer
                        you through our Site; to conduct quality assurance testing; to perform marketing; to run data analysis; to facilitate creation of accounts; to provide
                        technical support; and/or to provide other services to the Company.
                    </p>
                    <p>
                        Other Disclosures. Regardless of any choices you make regarding your Personal Information (as described below), Company may disclose Personal Information
                        if it believes in good faith that such disclosure is necessary (a) in connection with any legal investigation; (b) to comply with relevant laws or to
                        respond to subpoenas or warrants served on Company; (c) to protect or defend the rights or property of Company or users of the Services; and/or (d) to
                        investigate or assist in preventing any violation or potential violation of the law, this Privacy Policy, or Terms of Use.
                    </p>
                    <p>
                        <strong>Links to Third Party Websites</strong>
                    </p>
                    <p>
                        As part of the Service, we may provide links to or compatibility with other websites or applications. However, we are not responsible for the privacy
                        practices employed by those websites or the information or content they contain. This Privacy Policy applies solely to information collected by us through
                        the Site and the Service. Therefore, this Privacy Policy does not apply to your use of a third party website accessed by selecting a link on our Site or
                        via our Service. To the extent that you access or use the Service through or on another website or application, then the privacy policy of that other
                        website or application will apply to your access or use of that site or application. We encourage our users to read the privacy statements of other
                        websites before proceeding to use them.
                    </p>
                    <p>
                        <strong>Your Rights Regarding the Use of Your Personal Information</strong>
                    </p>
                    <p>
                        You have the right at any time to prevent us from contacting you for marketing purposes. When we send a promotional communication to a user, the user can
                        opt out of further promotional communications by following the unsubscribe instructions provided in each promotional e-mail. Please note that
                        notwithstanding the promotional preferences you indicate by either unsubscribing or opting out in the Settings section of your Account, we may continue to
                        send you administrative emails including, for example, periodic updates to our Privacy Policy.
                    </p>
                    <p>
                        <strong>Security of Your Personal Information</strong>
                    </p>
                    <p>
                        We implement security measures designed to protect your information from unauthorized access. Your account is protected by your account password and we
                        urge you to take steps to keep your personal information safe by not disclosing your password and by logging out of your account after each use. We further
                        protect your information from potential security breaches by implementing certain technological security measures However, these measures do not guarantee
                        that your information will not be accessed, disclosed, altered or destroyed by breach of such firewalls and secure server software. While we use reasonable
                        efforts to protect your Personal Information, we cannot guarantee its absolute security. By using our Service, you acknowledge that you understand and
                        agree to assume these risks
                    </p>
                    <p>
                        <strong>Changes to This Privacy Policy</strong>
                    </p>
                    <p>
                        We reserve the right to change this policy and our Terms of Service at any time. We will notify you of significant changes to our Privacy Policy by sending
                        a notice to the primary email address specified in your account or by placing a prominent notice on our site. Significant changes will go into effect 30
                        days following such notification. Non-material changes or clarifications will take effect immediately. You should periodically check the Site and this
                        privacy page for updates.
                    </p>
                    <p>
                        <strong>California Residents</strong>
                    </p>
                    <p>
                        California residents with an established business relationship with FreshBytes may contact us at info@freshbytes.io to request information
                        concerning our disclosure of your personal information to third parties for direct marketing purposes or to request to opt-out of any circumstance in which
                        your information may be shared with third parties for direct marketing purposes (California Civil Code Section 1798.83).
                    </p>
                    <p>
                        <strong>Contact Information</strong>
                    </p>
                    <p>
                        If you have any questions regarding this Privacy Policy or the practices of the Site or Mobile Application, please contact us by sending an email to
                        info@freshbytes.io.
                    </p>
                    <p>
                        <strong>Last Updated: </strong>
                        This Privacy Policy was last updated on April 21, 2016.
                    </p>
                  </div>
              </div>
            </div>
          </div>
        </div>
    </div>
);

export default Privacy;





// WEBPACK FOOTER //
// src/components/privacy.js